module.exports = __webpack_public_path__ + "2e5ece92530c0f593246c7b23b6d201a.svg";